import produce from "immer";
import {
  ADD_FULLY_FIT,
  ADD_FULLY_FIT_ERROR,
  ADD_FULLY_FIT_SUCCESS,
  EDIT_FULLY_FIT,
  EDIT_FULLY_FIT_SUCCESS,
  EDIT_FULLY_FIT_ERROR,
  DELETE_FULLY_FIT,
  DELETE_FULLY_FIT_ERROR,
  DELETE_FULLY_FIT_SUCCESS,
  GET_FULLY_FIT_LIST,
  GET_FULLY_FIT_LIST_ERROR,
  GET_FULLY_FIT_LIST_SUCCESS,
  DRAG_AND_DROP_PRODUCT,
} from "./actionTypes";

const initialState = {
  allFullyFitList: [],
  product: null,
  loading: false,
  error: "",
  totalPages: 0,
  limit: "",
  page: 1,
  sortOrder: "",
  sortField: "",
  search: "",
  addFullyFitLoad: false,
  deleteFullyFitLoad: false,
};

const fullyFitReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DRAG_AND_DROP_PRODUCT:
      return {
        ...state,
        allFullyFitList: payload,
      };
    case GET_FULLY_FIT_LIST:
      return {
        ...state,
        loading: true,
      };

    //set Challenges list
    case GET_FULLY_FIT_LIST_SUCCESS:
      return {
        ...state,
        allFullyFitList: payload,
        loading: false,
      };
    case GET_FULLY_FIT_LIST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    // Add FullyFit
    case ADD_FULLY_FIT:
      return {
        ...state,
        addFullyFitLoad: true,
      };
    case ADD_FULLY_FIT_SUCCESS:
      return {
        ...state,
        addFullyFitLoad: false,
      };
    case ADD_FULLY_FIT_ERROR:
      return {
        ...state,
        addFullyFitLoad: false,
      };

    // Edit FULLY_FIT
    case EDIT_FULLY_FIT:
      return {
        ...state,
        addFullyFitLoad: true,
      };
    case EDIT_FULLY_FIT_SUCCESS:
      return {
        ...state,
        addFullyFitLoad: false,
      };
    case EDIT_FULLY_FIT_ERROR:
      return {
        ...state,
        addFullyFitLoad: false,
      };

    //delete
    case DELETE_FULLY_FIT:
      return {
        ...state,
        deleteFullyFitLoad: true,
      };
    case DELETE_FULLY_FIT_SUCCESS:
      return {
        ...state,
        deleteFullyFitLoad: false,
      };
    case DELETE_FULLY_FIT_ERROR:
      return {
        ...state,
        deleteFullyFitLoad: false,
      };
    default:
      return state;
  }
});

export default fullyFitReducer;
